<template>
    <DefaultLayout
        :id="id"
        class="DateInput"
        input-container-class="DateInput__inputContainer"
        :class="{ 'DateInput--error': error, 'DateInput--disabled': disabled }"
        :label="label"
        :required="required"
        :error="error"
    >
        <q-input
            ref="inputRef"
            :model-value="value"
            class="DateInput__field"
            square
            outlined
            dense
            lazy-rules="ondemand"
            color="eidTrustGreen-75"
            :rules="rules"
            :disable="disabled"
            @change="onInputChange"
        >
            <template #append>
                <DateInputCalendar
                    :value="value"
                    :date-format="dateFormat"
                    :filter-func="filterFunc"
                    @input="onDateSelect"
                />
            </template>
        </q-input>
        <template
            v-for="name in DEFAULT_LAYOUT_SLOT_NAMES"
            #[name]
        >
            <slot :name="name" />
        </template>
    </DefaultLayout>
</template>
<style lang="scss">
@import "../style-variables.scss";

$dateInputSelector: ".DateInput__inputContainer .q-field__control";
$dateInputborderContainerSelector: "#{$dateInputSelector}::before, #{$dateInputSelector}::after";

.DateInput {
    &__inputContainer {
        @include input-container;
    }

    #{$dateInputborderContainerSelector} {
        border: none !important;

        &:hover, &:focus, &:active {
            border: none;
        }
    }

    #{$dateInputSelector} {
        padding: 8px;
        height: 100%;
    }

    &__field {
        @include input-field;
    }

    &--error {
        @include input-error-state(".DateInput__inputContainer");
    }

    &--disabled {
        @include input-disabled-state(".DateInput__inputContainer");
    }
}
</style>
<script lang="ts">
    import { defineComponent, PropType } from 'vue';

    import { QInput } from 'quasar';

    import { commonInputProps } from '@/modules/dynamic-form/components/style-inputs/common-input-props';
    import DefaultLayout from '@/modules/dynamic-form/components/style-inputs/default-layout/DefaultLayout.vue';
    import { defaultLayoutSlotForwardingMixin } from '@/modules/dynamic-form/components/style-inputs/default-layout-slot-forwarding.mixin';

    import DateInputCalendar from './sub-components/DateInputCalendar.vue';

    export default defineComponent({
        name: 'DateInput',
        components: { QInput, DefaultLayout, DateInputCalendar },
        mixins: [ defaultLayoutSlotForwardingMixin ],
        props: {
            ...commonInputProps,
            value: {
                type: String as PropType<string>,
                default: '',
            },
            filterFunc: {
                type: Function as PropType<(date: string) => boolean>,
                default: undefined,
            },
            dateFormat: {
                type: String as PropType<string>,
                default: 'M/D/YYYY',
            },
        },
        emits: [ 'change' ],
        data() {
            return {
                rules: [] as ((val: string) => boolean | string)[],
            };
        },
        methods: {
            onInputChange(this: any, event: Event): void {
                this.$emit('change', (event.target as HTMLInputElement)?.value as string);
            },
            onDateSelect(this: any, date: string): void {
                this.$emit('change', date);
            },
        },
    });
</script>

